/**
 * Trigger a browser download of the multi-sheet organizer workbook
 * (`event-planner-templates.xlsx`). Generated in-memory from the same
 * `IMPORT_SPECS` registry the dialogs validate against, so what the
 * organizer downloads is always in sync with what the admin will accept
 * on import.
 */
import { buildOrganizerWorkbook } from "./buildOrganizerWorkbook";

const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export async function downloadOrganizerWorkbook(
  filename = "event-planner-templates.xlsx",
): Promise<void> {
  const workbook = buildOrganizerWorkbook();
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer as ArrayBuffer], { type: XLSX_MIME });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke on next tick — some browsers race the click handler.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
